import { Controller } from 'stimulus';

export default class extends Controller {
  static get targets() {
    return ['dealerMargin', 'retailMargin'];
  }

  connect() {
    this.dealerMarginTarget.addEventListener('keyup', () => this.calcByDealerMargin());
  }

  calcByDealerMargin() {
    this.retailMarginTarget.value = (((this.dealerMarginTarget.value / 100 + 1) * 1.25 - 1) * 100).toFixed(2);
  }
}
